import { render, staticRenderFns } from "./ChannelListView.vue?vue&type=template&id=2bfc273c&scoped=true&"
import script from "./ChannelListView.vue?vue&type=script&lang=js&"
export * from "./ChannelListView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelListView.vue?vue&type=style&index=0&id=2bfc273c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc273c",
  null
  
)

export default component.exports